import {useState, useEffect, useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {getCurrentRole} from '../actions/login';

export default function () {
    const dispatch = useDispatch();
    const [role, setRole] = useState({});

    useEffect(() => {
        fetchRole();
    }, []);

    const fetchRole = useCallback(async () => {
        const data = await dispatch(getCurrentRole());
        setRole(data);
    }, []);

    return role;
}